import React from 'react';
import * as styles from './MembershipGroups.module.scss';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import Link from '../utils/router/Link';
import groupPath from '../utils/url/groupPath';

const MEMBERSHIP_GROUPS_GROUPS_FRAGMENT = gql(`
  fragment MembershipGroups_groups on Group {
    id
    name
    ...groupPath_group
  }
`);

interface MembershipGroupsProps {
  membershipGroups: DocumentType<typeof MEMBERSHIP_GROUPS_GROUPS_FRAGMENT>[];
}

const MembershipGroups = ({ membershipGroups }: MembershipGroupsProps) => (
  <ul className={styles.content}>
    {membershipGroups && membershipGroups.length > 0 ? (
      membershipGroups.map((membershipGroup) => (
        <li key={membershipGroup.id}>
          <Link className={styles.group} to={groupPath(membershipGroup)}>
            {membershipGroup.name}
          </Link>
        </li>
      ))
    ) : (
      <div className={styles.empty}>No memberships yet</div>
    )}
  </ul>
);

export default MembershipGroups;
